import { InvoiceDetailsPagePolaris } from "../components/admin/invoices/InvoiceDetailsPagePolaris";
import MainLayout from "../layout/MainLayout";
import { InvoicesPagePolaris } from "../pages/admin/InvoicesPagePolaris";
import {
  AmazonChannelPage,
  EbayChannelPage,
  EtsyChannelPage,
  FacebookMKPage,
  OnlineStoresPage,
  TiktokChannelPage,
} from "../pages/reports";
import { DesignTasksPagePolaris } from "../pages/seller/DesignTasksPagePolaris";
import { OrdersPagePolaris } from "../pages/seller/OrdersPagePolaris";
import { OrdersPagePolaris2 } from '../pages/seller/OrdersPagePolaris2';
import { PaymentAccounts } from "../pages/seller/PaymentAccount";

const routes = [
  {
    path: "/seller-accountant/reports/amazon",
    exact: true,
    component: AmazonChannelPage,
    title: "Amazon Channel Page",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "Accountant",
  },
  {
    path: "/seller-accountant/reports/tiktok",
    exact: true,
    component: TiktokChannelPage,
    title: "Tiktok Channel Page",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "Accountant",
  },
  {
    path: "/seller-accountant/reports/facebook-mk",
    exact: true,
    component: FacebookMKPage,
    title: "Facebook Marketplace Channel Page",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "Accountant",
  },
  {
    path: "/seller-accountant/reports/online-stores",
    exact: true,
    component: OnlineStoresPage,
    title: "Online stores Page",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "Accountant",
  },
  {
    path: "/seller-accountant/reports/etsy",
    exact: true,
    component: EtsyChannelPage,
    title: "Etsy Channel Page",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "Accountant",
  },
  {
    path: "/seller-accountant/reports/ebay",
    exact: true,
    component: EbayChannelPage,
    title: "Ebay Channel Page",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "Accountant",
  },
  {
    path: "/seller-accountant/design-tasks",
    exact: true,
    // component: DesignTasksPage,
    component: DesignTasksPagePolaris,
    title: "All Tasks",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "Accountant",
  },
  {
    path: "/seller-accountant/billings/invoices",
    exact: true,
    // component: DesignTasksPage,
    component: InvoicesPagePolaris,
    title: "All Invoices",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "Accountant",
  },
  {
    path: "/seller-accountant/billings/invoice/:id",
    exact: true,
    component: InvoiceDetailsPagePolaris,
    title: "Invoice Detail",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "Accountant",
  },
  {
    path: "/seller-accountant/orders2",
    exact: true,
    component: OrdersPagePolaris,
    layout: MainLayout,
    title: "Orders",
    roles: ["Seller"],
    teamRole: "Accountant",
  },
  {
    path: "/seller-accountant/orders",
    exact: true,
    component: OrdersPagePolaris2,
    layout: MainLayout,
    title: "Orders",
    roles: ["Seller"],
    teamRole: "Accountant",
  },
  {
    path: "/seller-accountant/settings/payment-accounts",
    exact: true,
    component: PaymentAccounts,
    title: "Payment Accounts",
    layout: MainLayout,
    roles: ["Seller"],
    teamRole: "Accountant",
  },
];

export default routes;
